var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediumBuildingChosen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171.435,
    height: 186,
    viewBox: "0 0 171.435 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2,.cls-3{fill:none;stroke:#4b4b4b;stroke-miterlimit:10;stroke-width:3px}.cls-3{fill:#13647b}.cls-4{fill:#dcdcdc}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medium_building",
    transform: "translate(-1024.565 -329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_809",
    fill: "none",
    d: "M0 0H171V186H0z",
    transform: "translate(1025 329)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    transform: "translate(1077.852 387.382)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_766",
    width: 72,
    height: 122,
    className: "cls-2",
    rx: 11.299,
    transform: "translate(.148 -.382)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_767",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(25.563 102.252)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_768",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(11.224 40.901)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_769",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(40.137 40.901)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_770",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(11.224 68.403)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_771",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(40.137 68.403)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_772",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(11.224 13.399)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_773",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(40.137 13.399)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    transform: "translate(990.66 235.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    d: "M80.045 134.634c1.29-.041 3-.514 2.961-1.8-2.173-2.171-5.668-1.966-8.738-1.876s-6.746-.455-8.059-3.231c-.59-1.245-.631-2.84-1.707-3.7-1.385-1.108-3.951-.513-4.7-2.123-.458-.99.171-2.108.386-3.178a5.366 5.366 0 0 0-2.369-5.184 11.079 11.079 0 0 0-5.7-1.723c-3.368-.238-7.473.772-8.469 4-.507 1.641-.035 3.413-.155 5.126s-1.325 3.664-3.03 3.457l-.085 3.465a13.452 13.452 0 0 0-7.181 2.318 6.493 6.493 0 0 1-1.958 1.1c-1.789.455-3.911-.982-5.411.095-.7.5-.992 1.411-1.624 2a4.806 4.806 0 0 1-2.308.965c-3.667.817-7.347 1.592-11 2.463 10.334-1.02 20.532-3.006 30.947-3.1 12.747-.127 25.455 1.327 38.2.926z",
    className: "cls-4",
    transform: "translate(23 -8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    d: "M140.338 146.011a45.216 45.216 0 0 1 13.109-2.133c-.489-1.091.453-2.254 1.316-3.079l7.243-6.917a8.743 8.743 0 0 1 2.03-1.587c1.04-.524 2.285-.631 3.217-1.33 1.934-1.452 1.619-4.688 3.467-6.25 1.66-1.4 4.239-.753 6.05.446a12.812 12.812 0 0 1 5.631 9.914c.048 1.024.02 2.18.746 2.9.79.787 2.066.671 3.178.6a29.942 29.942 0 0 1 7.81.779 85.168 85.168 0 0 1 10.155 2.749 25.538 25.538 0 0 1 5.381 2.263c-2.261 2.853-12.182 1.772-15.825 1.937q-8.913.406-17.836.507-17.843.212-35.672-.799z",
    className: "cls-4",
    transform: "translate(-5.667 -1.072)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumBuildingChosen);
export default __webpack_public_path__ + "static/media/medium-building-chosen.acd226cad988957d3d4ff5d7f6a9484a.svg";
export { ForwardRef as ReactComponent };